/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var Observable = require('rxjs/Observable');
var merge = require('rxjs/observable/merge');
var distinctUntilChanged = require('rxjs/operator/distinctUntilChanged');
var map = require('rxjs/operator/map');
var throttleTime = require('rxjs/operator/throttleTime');
var minilo = require('../util/minilo');
var fromOlEvent = _interopDefault(require('./from-ol-event'));

/**
 * Creates Observable from OpenLayers change:* event
 * @param {ol.Object} target
 * @param {string|string[]} [prop]
 * @param {boolean|function(a, b):boolean|undefined} [distinct] Distinct values by isEqual fn or by custom comparator
 * @param {number|undefined} [throttle] Throttle values by passed amount of ms.
 * @param {function(target: ol.Object, prop: string):*|undefined} [selector] Custom selector
 * @return {Observable<{prop: string, value: *}>}
 */
function fromOlChangeEvent(target, prop, distinct, throttle, selector) {
  var _context3;

  if (Array.isArray(prop)) {
    return merge.merge.call.apply(merge.merge, [Observable.Observable].concat(_toConsumableArray(prop.map(function (p) {
      return fromOlChangeEvent(target, p);
    }))));
  }

  selector = selector || function (target, prop) {
    return target.get(prop);
  };
  var event = 'change:' + prop;
  var observable = fromOlEvent(target, event, function () {
    return selector(target, prop);
  });

  if (throttle != null) {
    var _context;

    observable = (_context = observable, throttleTime.throttleTime).call(_context, throttle);
  }
  if (distinct) {
    var _context2;

    minilo.isFunction(distinct) || (distinct = minilo.isEqual);
    observable = (_context2 = observable, distinctUntilChanged.distinctUntilChanged).call(_context2, distinct);
  }

  return (_context3 = observable, map.map).call(_context3, function (value) {
    return { prop: prop, value: value };
  });
}

module.exports = fromOlChangeEvent;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/rx-ext/from-ol-change-event.js
// module id = 174
// module chunks = 1